// src/components/FeaturePageLayout.js
import React from 'react';

// Import all components
import SEO from './SEO';
import Testimonials from './Testimonials';
import FinalCTA from './FinalCTA';
import FeatureHero from './FeatureHero';
import FeatureSection from './FeatureSection';
import BenefitGrid from './BenefitGrid';
import StepByStepGuide from './StepByStepGuide';
import TargetAudience from './TargetAudience'; // ✅ Import the new component
import BlogPreview from './BlogPreview';

const FeaturePageLayout = ({ pageData }) => {
  return (
    <>
      <SEO 
        title={pageData.seo.title}
        description={pageData.seo.description}
        image={pageData.seo.image}
        schemas={pageData.seo.schemas}
      />
      
      <main className="bg-dark-bg text-dark-text-secondary font-sans animate-fade-in">
        <div className="relative isolate">
          <FeatureHero
            icon={pageData.hero.icon}
            title={pageData.hero.title}
            subtitle={pageData.hero.subtitle}
            backgroundImage={pageData.hero.backgroundImage}
          />
          
          <FeatureSection
            title={pageData.featureSection.title}
            subtitle={pageData.featureSection.subtitle}
            features={pageData.featureSection.features}
          />

          <BenefitGrid
            title={pageData.benefitGrid.title}
            benefits={pageData.benefitGrid.benefits}
          />

          <StepByStepGuide
            title={pageData.stepByStep.title}
            subtitle={pageData.stepByStep.subtitle}
            steps={pageData.stepByStep.steps}
          />
          
          {/* ✅ Replace CustomerLogos with TargetAudience */}
          <TargetAudience
            title={pageData.targetAudience.title}
            // In the future, you could pass custom audiences here if needed
            // audiences={pageData.targetAudience.audiences} 
          />

          <Testimonials />
          
          <BlogPreview shuffle={true} />
          
          <FinalCTA />
        </div>
      </main>
    </>
  );
};

export default FeaturePageLayout;